<template>
  <div class="w-full flex items-center justify-start py-4">
    <img src="@/assets/docs-assets/logo.webp" alt="Cashflow Casino" class="h-[8vw] min-h-[40px] md:h-[6vw] w-auto object-contain" />
  </div>
</template>
